import {Component, OnInit} from '@angular/core';

@Component({
    selector: 'app-student-testimonial',
    templateUrl: './student-testimonial.component.html',
    styleUrls: ['./student-testimonial.component.scss']
})
export class StudentTestimonialComponent implements OnInit {
    // testimonialSlideIndex: number = 0;
    // testimonialSlidesCount: number = 3;


    testimonials = [
        {
            name: 'Abhishek Bhatia',
            course: 'B. Tech Civil',
            company: 'Jal Shakti Vibhag',
            image: 'assets/img/alumni-connect/alumni/alumni19.webp',
            feedback: `I am very grateful to ARNI University for shaping my career and helping me achieve my dream of becoming a civil engineer. The university’s practical learning approach, expert faculty, and well-equipped labs played a crucial role in building my technical expertise. On-site training and project work enhanced my knowledge base.`,
        },
        {
            name: 'Waseem Akram',
            course: 'M. Tech Civil',
            company: 'Shree Cement Ltd.',
            image: 'assets/img/alumni-connect/alumni/alumni20.webp',
            feedback: `I am very grateful to ARNI University – both the faculty and administrative departments. In my 2-year learning journey, I have never faced an issue regarding any studies, accommodations, or administrative work. They were superfast and efficient in their work and responsibilities. I had a great time over there.`,
        },
        {
            name: 'Pradeep Singh',
            course: 'B. Tech Mechanical',
            company: 'IIT Jammu',
            image: 'assets/img/alumni-connect/alumni/alumni18.webp',
            feedback: `The student support cell and placement cell are truly working hard for the comfort and success of the students. Due to their priceless efforts and constant guidance, I was able to bag a job in one of the most reputable organizations. They kept me updated about the placement drives and provided valuable tips and insights to help me grab the opportunity.`,
        },
        {
            name: 'Barun Sharma',
            course: 'B. Tech Mechanical',
            company: 'Public Works Department Jammu',
            image: 'assets/img/alumni-connect/alumni/alumni6.webp',
            feedback: `ARNI University is not just like another educational institute that only provides degrees. They are enlightened path of students with their highly professional teachers and admins for last long impact in personal & professional lives. I have gained exceptional skills that helps me to accomplish my career goals. `,
        },
        {
            name: 'Harshal Singh Thakur',
            course: 'B. Tech CSE',
            company: 'Genpact Bengaluru',
            image: 'assets/img/home-page-testimonials/harshal-singh.webp',
            feedback: `Apart from the studies and their positive behavior towards students, the one thing I loved about this university is its placement services. They have collaborated with big companies, which helps students to get real-world experience and internships with minimum effort.`,
        },
        {
            name: 'Nalin Dhiman',
            course: 'MCA',
            company: 'Stellar Innovations Pvt. Ltd.',
            image: 'assets/img/alumni-connect/alumni/alumni1.webp',
            feedback: `ARNI University is such a great place to learn. I have completed my MCA from this university, which has helped me to accomplish my career goals. They have fully furnished and well-maintained labs and allow easy access to the students. Faculty and administrations are supportive and student-oriented.`,
        },
        {
            name: 'Bhawna',
            course: 'MBA',
            company: '',
            image: 'assets/img/alumni-connect/alumni/alumni14.webp',
            feedback: `ARNI is not only focused on theoretical learning; the faculty is doing its best to increase the practical knowledge of the students as well. They offer live projects, case studies and encourage students to think beyond the textbooks. The hands-on experience I gained here helped me to secure a job in a well-reputed company.`,
        },
        {
            name: 'Geetika Katoch',
            course: 'MBA in HR',
            company: '',
            image: 'assets/img/alumni-connect/alumni/alumni13.webp',
            feedback: `The professors at ARNI are not just teachers; they are mentors who guide you at every step. Their real-world experience and industry insights make learning so much more engaging. Thanks to their career counseling, I was able to choose the right specialization for my MBA!`,
        },
        {
            name: 'Pallavi Chauhan',
            course: 'M.sc. - Physics',
            designation: 'J&K Bank',
            image: 'assets/img/home-page-testimonials/pallavi-chauhan.webp',
            feedback: `ARNI University provides an excellent platform to those who have an interest in
                                    research and technology. The professors are well-mannered and talented, ensure
                                    student growth. The laboratory is equipped with all the necessary equipments. The
                                    emphasis on research ethics and
                                    innovation has given me the confidence to pursue my dream of contributing to
                                    physical advancements.`,
        },
        {
            name: 'Punchok Lamo',
            course: 'M.Sc. - Physics',
            designation: 'Govt. Teacher',
            image: 'assets/img/home-page-testimonials/punchok-lamo.webp',
            feedback: `Throughout my learning journey at ARNI University, I was always encouraged to focus
                                    on practical learning. The faculty organized science fairs, conducted open
                                    experiment classes, analyzed our data, and helped to develop critical thinking
                                    skills. Lectures from industry experts keep us updated with real-world scenarios and
                                    boost our confidence.`,
        },
        {
            name: 'Vinit Gupta',
            course: 'Diploma in Pharmacy',
            designation: 'Garg Pharma',
            image: 'assets/img/home-page-testimonials/vinit-gupta.webp',
            feedback: `I was a little nervous and worried about the course curriculum when I joined this
                                    program. But the best student support and world-class faculty made everything easy
                                    and synchronized for me. The faculty members are absolutely knowledgeable and always
                                    ready to help whenever required. Apart from theoretical learning, they focus on
                                    applying what we learn. I had a great time here!`,
        },
       /* {
            name: 'Ravi Sharma',
            course: 'Bachelor of Physical Education & Sports',
            company: '',
            image: 'https://randomuser.me/api/portraits/men/52.jpg',
            feedback: `The real foundation of ARNI is its sports instructors. They constantly encourage us to perform better and are very personable and supportive. They act as mentors to us, helping us with everything from lesson planning to exam or event preparation. I'm constantly inspired to set higher goals.`,
        },


        {
            name: 'Pallavi Chauhan',
            course: 'M.sc. - Physics',
            designation: 'J&K Bank',
            image: 'assets/img/home-page-testimonials/pallavi-chauhan.webp',
            feedback: `ARNI University provides an excellent platform to those who have an interest in
                                    research and technology. The professors are well-mannered and talented, ensure
                                    student growth. The laboratory is equipped with all the necessary equipments. The
                                    emphasis on research ethics and
                                    innovation has given me the confidence to pursue my dream of contributing to
                                    physical advancements.`,
        },
        {
            name: 'Punchok Lamo',
            course: 'M.Sc. - Physics',
            designation: 'Govt. Teacher',
            image: 'assets/img/home-page-testimonials/punchok-lamo.webp',
            feedback: `Throughout my learning journey at ARNI University, I was always encouraged to focus
                                    on practical learning. The faculty organized science fairs, conducted open
                                    experiment classes, analyzed our data, and helped to develop critical thinking
                                    skills. Lectures from industry experts keep us updated with real-world scenarios and
                                    boost our confidence.`,
        },
        {
            name: 'Rohit Verma',
            course: 'BA LLB',
            company: '',
            image: 'https://randomuser.me/api/portraits/men/42.jpg',
            feedback: `Having a degree in Law from ARNI was the best decision of my career. I have polished my critical thinking skills, built confidence that helps me to present arguments with confidence in the right direction. The course curriculum strengthened my foundation towards Indian Laws that provide me a successful career as a legal professional.`,
        },
        {
            name: 'Vinit Gupta',
            course: 'Diploma in Pharmacy',
            designation: 'Garg Pharma',
            image: 'assets/img/home-page-testimonials/vinit-gupta.webp',
            feedback: `I was a little nervous and worried about the course curriculum when I joined this
                                    program. But the best student support and world-class faculty made everything easy
                                    and synchronized for me. The faculty members are absolutely knowledgeable and always
                                    ready to help whenever required. Apart from theoretical learning, they focus on
                                    applying what we learn. I had a great time here!`,
        },
        {
            name: 'Meera Joshi',
            course: 'Bachelor of Physical Education & Sports',
            company: '',
            image: 'https://randomuser.me/api/portraits/women/52.jpg',
            feedback: `What I love most about studying here is how the program focuses on overall development. We get opportunities to participate in cultural events, debates, community teaching programs, and sports events. It has helped me become more confident, expressive, and balanced as a person.`,
        },

        {
            name: 'Geetika Katoch',
            course: 'MBA in HR',
            designation: 'Hitech Engineering Industry, Malot',
            image: 'assets/img/home-page-testimonials/geetika-katoch.webp',
            feedback: `  The professors at ARNI are not just teachers; they are mentors who guide you at
                                    every step. Their real-world experience and industry insights make learning so much
                                    more engaging. Thanks to their career counseling, I was able to choose the right
                                    specialization for my MBA!`,
        },
        {
            name: 'Bhaskar Sharma',
            course: 'Diploma in Pharmacy',
            company: '',
            image: 'https://randomuser.me/api/portraits/men/43.jpg',
            feedback: `ARNI is the best place for those who want to develop their skills and knowledge, as the university offers easy access to well-maintained labs and equipment, which is rare to find nowadays. Apart from the syllabus, I have learned many other things too that provide me a strong foundation to work in a diverse environment.`,
        },

        {
            name: 'Aditya Singh',
            course: 'LLB',
            company: '',
            image: 'https://randomuser.me/api/portraits/men/44.jpg',
            feedback: `The professors at the university are very knowledgeable and approachable. They don’t just focus on the textbook syllabus—they help to connect law with real-life situations. This makes learning more engaging and meaningful. I always got support from the faculty in terms of learning or any other issues.`,
        },
        {
            name: 'Hriday Thakur',
            course: 'Diploma in Pharmacy',
            company: '',
            image: 'https://randomuser.me/api/portraits/men/43.jpg',
            feedback: `ARNI offers regular visits of guest lecturers, seminars, industry professionals, and inter-colleges visits helps to boost networking opportunities and keep the students updated with the latest happenings around the world. These activities helped me to collaborate with industry experts that provided me a job before I completed my degree.`,
        },

        {
            name: 'Harshal Singh Thakur',
            course: 'B. Tech CSE',
            designation: 'Genpact Bengaluru',
            image: 'assets/img/home-page-testimonials/harshal-singh.webp',
            feedback: `Apart from the studies and their positive behavior towards students, the one thing I loved about this university is its placement services. They have collaborated with big companies, which helps students to get real-world experience and internships with minimum effort.`,
        },*/
    ];

    aarniSchoolsList = [
        'School of Technology',
        'School of Business Management & Commerce',
        'School of Art & Humanities',
        'School of Basic Sciences & Bio-Technology',
        'School of Allied Health Sciences',
        'School of Pharmacy',
        'School of Agriculture',
        'School of Law',
        'School of Hotel Management & Tourism',
        'School of Education & Sports'
    ];

    constructor() {
    }

    ngOnInit(): void {
    }

    // setTestimonialSlide(index: number) {
    //     this.testimonialSlideIndex = index;
    // }
}
